"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import {
  useGetCampaign,
  useStaffGetDocumentsForCampaign,
} from '@urbanx/agx.campaigns.client'
import { AgxLoadingState } from '@urbanx/agx.ui-components2'
import TaskModalDialog from 'pages/allTasks/TaskModal/TaskModalDialog'
import { TaskModalPageProps } from 'pages/allTasks/TaskModal/TaskModalPageProps'
import { useCallback } from 'react'
import ExchangeTaskPage from './ExchangeTaskPage'

interface ExchangeTaskModalProps {
  campaignId: string
  isOpen: boolean
  onClose: () => void
  task: AutopilotTaskDto
  title: string
}

const ExchangeTaskModal = ({
  campaignId,
  isOpen,
  onClose,
  task,
  title,
}: ExchangeTaskModalProps) => {
  const { data: campaign, isPending: isCampaignPending } = useGetCampaign(
    campaignId,
    !!campaignId
  )

  const { data: documentGroups, isPending: documentsPending } =
    useStaffGetDocumentsForCampaign(campaignId, !!campaignId && isOpen)

  const renderPage = useCallback(
    (props: TaskModalPageProps) =>
      isCampaignPending || documentsPending ? (
        <AgxLoadingState />
      ) : (
        <ExchangeTaskPage {...props} />
      ),
    [documentsPending, isCampaignPending]
  )

  if (!campaign) return null

  return (
    <TaskModalDialog
      title={title}
      tasks={[task]}
      open={isOpen}
      onClose={onClose}
      documents={documentGroups ?? []}
      campaignId={campaignId}
      campaign={campaign}
      renderPage={renderPage}
    />
  )
}

export default ExchangeTaskModal
